<template>
  <div class="card">
    <div class="card-body overflow-auto chat" ref="chatContainer">
      <div ref="chatContent">
        <div
          v-for="(message, index) in messages"
          :key="message.id"
        >
          <div class="row">
            <div class="col">
              <b>{{ message.author }}</b>
              <span class="small" :id="'message-'+message.id">
                            {{ message.created_at | relative }}
                        </span>
              <b-tooltip :target="'message-'+message.id" triggers="hover">
                {{ message.created_at | exact }}
              </b-tooltip>
            </div>
            <div class="col-auto">
              <button @click="replyTo(message.id)" class="btn btn-primary btn-sm"><i class="fas fa-reply"></i></button>
            </div>
          </div>
          <div class="small" v-if="message.reply_to !== null">
            <b>In risposta a {{ message.reply_to_author }}:</b> {{ message.reply_to.content }}
          </div>
          {{ message.content }}
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require('axios');
const moment = require('moment');

export default {
  name: "Chat",
  data() {
    return {
      messages: [],
    }
  },
  filters: {
    relative: function (date) {
      moment.locale('it');
      return moment(date).fromNow();
    },
    exact: function (date) {
      moment.locale('it');
      return moment(date).format("LLL");
    }
  },
  props: {
    eventId: String,
    prefix: {
      type: String,
      default: '',
    }
  },
  methods: {
    replyTo(id) {
      Livewire.emit('selectedReplyTo', id);
    },
  },
  mounted() {
    axios.get(`${this.$props.prefix}/get_old_messages`).then(function (response) {
      this.messages = response.data;
      Echo.channel(`event.${this.eventId}`)
        .listen('ChatMessageReceived', (e) => {
          this.messages.push(e.chatMessage)
          this.messages.sort(function (a, b) {
            const aDate = moment(a.created_at);
            const bDate = moment(b.created_at);
            if (aDate.isBefore(bDate)) {
              return -1;
            } else if (aDate.isAfter(bDate)) {
              return 1;
            } else {
              return 0;
            }
          });
        })
        .listen('ChatMessageDeleted', (e) => {
          this.messages = this.messages.filter((item) => {
            return item.id !== e.chatMessageId;
          })
        });
    }.bind(this));
  },
  updated() {
    this.$refs.chatContainer.scrollTop = this.$refs.chatContent.clientHeight;
  },
}
</script>

<style scoped>
.chat {
  height: 400px;
}
</style>
